"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FingerDrawOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M14,4a2,2,0,0,1,2,2v8.271l9.275,1.181a2,2,0,0,1,1.71,2.23L25.694,28H14a2.158,2.158,0,0,1-.35-.036l-.116-.026a2.846,2.846,0,0,1-.279-.092l-.092-.036c-.069-.033-8.235-5.123-8.235-5.123a2,2,0,0,1,.622-3.638A2.886,2.886,0,0,1,6.2,18.97a1.588,1.588,0,0,1,.865.225L12,21.829V6a2,2,0,0,1,2-2m0-2a4,4,0,0,0-4,4V18.5l-1.88-1A3.577,3.577,0,0,0,6.2,16.97,4.857,4.857,0,0,0,5.1,17.1a4,4,0,0,0-1.22,7.29l8,5a.037.037,0,0,0,.03.01,4.111,4.111,0,0,0,.51.27.487.487,0,0,0,.11.04,5.223,5.223,0,0,0,.56.18c.07.01.13.03.19.04A4.285,4.285,0,0,0,14,30h11.69a2.007,2.007,0,0,0,1.99-1.75l1.29-10.32a4,4,0,0,0-3.43-4.46L18,12.51V6a4,4,0,0,0-4-4Z"/><path d="M29.005,10a1,1,0,0,1-.857-.483A9.974,9.974,0,0,0,20,5a1,1,0,0,1,0-2,12.009,12.009,0,0,1,9.858,5.485A1,1,0,0,1,29.005,10Z"/>';
var FingerDrawOutlineSVG = function FingerDrawOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.FingerDrawOutlineSVG = FingerDrawOutlineSVG;
FingerDrawOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FingerDrawOutlineSVG);
exports.default = _default;